import { render, staticRenderFns } from "./TaskView.vue?vue&type=template&id=3b7f06fa&scoped=true&"
import script from "./TaskView.vue?vue&type=script&lang=js&"
export * from "./TaskView.vue?vue&type=script&lang=js&"
import style0 from "./TaskView.vue?vue&type=style&index=0&id=3b7f06fa&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b7f06fa",
  null
  
)

export default component.exports